import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import CardImg from "../card/CardImg";
import { IoMdClose } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import featured from "./featured.png";

import { deleteCart, updateCart } from "../../features/apiCall";
import { useGetCategoryQuery } from "../../features/productsApi";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const CartItem = ({ cartItem }) => {
  const { isFetching, cartItems } = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  const [count, setCount] = useState(cartItem?.quantity);
  const [category, setCategory] = useState();
  const navigate = useNavigate();

  const toastOptions = {
    position: "bottom-center",
    autoClose: 3000,
    pauseOnHover: true,
    draggable: true,
    theme: "dark",
  };

  const { data: categoryData, isLoading: categoryLoading } =
    useGetCategoryQuery(cartItem?.product?.category);

  useEffect(() => {
    if (categoryData) {
      setCategory(categoryData?.category);
    }
  }, [categoryData]);

  const prodId = cartItem?.product?._id;

  const handleCount = (change) => {
    if (change === "dec") {
      if (count === 1) {
        setCount(count);
        deleteCart(dispatch, { prodId });
        toast.error("Product deleted!", toastOptions);
      } else {
        setCount(count - 1);
      }
    }

    if (change === "inc") {
      setCount(count + 1);
    }
  };

  useEffect(() => {
    if (count !== cartItem?.quantity) {
      // toast.success("Product updated!", toastOptions);
      updateCart(dispatch, { prodId, count });
    }
  }, [count, cartItem?.quantity, prodId, dispatch]);

  const handleDelete = () => {
    deleteCart(dispatch, { prodId });
    toast.error("Product deleted!", toastOptions);
  };

  return (
    <>
      <div className="cart-item">
        <div className="cart-prod-remove-btn">
          <IoMdClose
            className="cart-icon-delete"
            onClick={() => handleDelete()}
          />
        </div>
        <Row className="cart-cont">
          <Col md={4} lg={2} xs={4}>
            <img
              src={cartItem?.product?.product_images[0]}
              alt="productImage"
              className="cart-item-img"
            />
            {/* <CardImg imgPath={featured} /> */}
          </Col>
          <Col md={8} lg={6} xs={8}>
            {isFetching ? (
              <div className="overlay-cart">
                <p
                  className="cart-prod-name"
                  // onClick={() => navigate(`/home/${cartItem?.product?._id}`)}
                >
                  {cartItem?.product?.name?.slice(0, 40)}...
                </p>
                <p
                  className="cart-prod-cate"
                  // onClick={() =>
                  //   navigate(`/shop/${cartItem?.product?.category}`)
                  // }
                >
                  {category?.name}
                </p>
                <p className="cart-prod-price">
                  €{cartItem?.product?.amount?.toFixed(2)}
                </p>

                {cartItem?.installationDate ? (
                  <p className="prod-install-date">
                    Your preferred installation date:{" "}
                    <span
                      style={{
                        fontWeight: "600",
                      }}
                    >
                      {moment(cartItem?.installationDate)
                        .utc()
                        .format("MMMM DD, YYYY")}
                    </span>
                  </p>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <>
                <p
                  className="cart-prod-name"
                  onClick={() => navigate(`/home/${cartItem?.product?._id}`)}
                >
                  {cartItem?.product?.name?.slice(0, 40)}...
                  {/* Loom Solar Panel 10 watt - 12 volt for Mobile */}
                </p>
                <p
                  className="cart-prod-cate"
                  onClick={() =>
                    navigate(`/shop/${cartItem?.product?.category}`)
                  }
                >
                  {category?.name}
                  {/* Baxter */}
                </p>
                <p className="cart-prod-price">
                  €{cartItem?.product?.amount?.toFixed(2)}
                  {/* $ 70.00 */}
                </p>

                {cartItem?.installationDate ? (
                  <p className="prod-install-date">
                    Your preferred installation date:{" "}
                    <span
                      style={{
                        fontWeight: "600",
                      }}
                    >
                      {moment(cartItem?.installationDate)
                        .utc()
                        .format("MMMM DD, YYYY")}
                    </span>
                  </p>
                ) : (
                  ""
                )}
              </>
            )}
          </Col>

          <Col>
            <div className="btn-box">
              {/* <IoMdClose className="close-btn" /> */}
              <div className="prod-btn-box-1">
                {isFetching ? (
                  <div
                    style={{
                      opacity: 0.5,
                    }}
                  >
                    -
                  </div>
                ) : (
                  <div onClick={() => handleCount("dec")}>-</div>
                )}
                {/* <div>-</div> */}
                {/* <span>{1}</span> */}
                <span>{count}</span>
                {/* <div>+</div> */}
                {isFetching ? (
                  <div
                    style={{
                      opacity: 0.5,
                    }}
                  >
                    +
                  </div>
                ) : (
                  <div onClick={() => handleCount("inc")}>+</div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <ToastContainer />
    </>
  );
};

export default CartItem;
